export default "https://cdn-static.gokick.com/assets/fe83fbcc8f1f3696644045565519fd390c3f6ffc/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";